import {DeleteOutlined, PlusOutlined} from '@ant-design/icons';
import {Badge, Button, Form, Input} from 'antd';
import {Rule} from 'antd/es/form';
import React, {FC} from 'react';

import {DateInput} from 'components/@common/inputs/date-input';
import {DATE_DMY} from 'shared/constants/date-format';

import {maxSizeRule} from '../../lib';

interface IProductsListProps {
    factorFieldName: number;
    validateProductsRequired?: (factorTypeCodeId: number | null | undefined) => Rule;
    isReadOnly?: boolean;
}

export const ProductsList: FC<IProductsListProps> = ({
    factorFieldName,
    validateProductsRequired,
    isReadOnly = false,
}: IProductsListProps) => (
    <div className="products-list">
            <Form.Item
                shouldUpdate={(prevValues, currentValues) => {
                    const prevFactorTypeCode = prevValues.factors?.[factorFieldName]?.factorTypeCodeId;
                    const currentFactorTypeCode = currentValues.factors?.[factorFieldName]?.factorTypeCodeId;
                    return prevFactorTypeCode !== currentFactorTypeCode;
                }}
                noStyle
            >
                {({getFieldValue}) => {
                    const factorTypeCodeId = getFieldValue(['factors', factorFieldName, 'factorTypeCodeId']);
                    
                    if (!validateProductsRequired) {
                        return null;
                    }
                    
                    return (
                        <Form.Item
                            name={[factorFieldName, 'prods']}
                            rules={[validateProductsRequired(factorTypeCodeId)]}
                            dependencies={[['factors', factorFieldName, 'factorTypeCodeId']]}
                            noStyle
                        />
                    );
                }}
            </Form.Item>
            <Form.List name={[factorFieldName, 'prods']}>
                {(productFields, {add, remove}) => (
                    <>
                        <Badge count={productFields.length} className="add-product-badge">
                            <Button
                                type="primary"
                                onClick={() => add()}
                                icon={<PlusOutlined />}
                                className="add-product-button"
                                disabled={isReadOnly}
                            >
                                Добавить товар
                            </Button>
                        </Badge>
                        
                        {productFields.map((productField) => (
                            <div 
                                key={productField.key}
                                className="product-item-block"
                            >
                                <Button
                                    type="text"
                                    danger
                                    icon={<DeleteOutlined />}
                                    onClick={() => remove(productField.name)}
                                    className="delete-button"
                                    disabled={isReadOnly}
                                />
                                <div className="form-flex-row">
                                    <Form.Item
                                        name={[productField.name, 'tnvedCode']}
                                        label="Код товара в соответствии с ТН ВЭД ЕАЭС"
                                        rules={[
                                            {required: true, message: 'Обязательное поле'},
                                            {min: 6, message: 'Минимальная длина 6 символов'},
                                            {max: 10, message: 'Максимальная длина 10 символов'},
                                        ]}
                                        validateTrigger={['onBlur']}
                                    >
                                        <Input
                                            disabled={isReadOnly}
                                            placeholder="Введите значение"
                                            autoComplete="off"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name={[productField.name, 'prodName']}
                                        label="Наименование товара"
                                        rules={[
                                            {required: true, message: 'Обязательное поле'},
                                            maxSizeRule(1000),
                                        ]}
                                    >
                                        <Input disabled={isReadOnly} type='text'/>
                                    </Form.Item>
                                    <Form.Item
                                        name={[productField.name, 'establishDate']}
                                        label="Дата введения запрета/установления предельного размера цен"
                                    >
                                        <DateInput disabled={isReadOnly} format={DATE_DMY} />
                                    </Form.Item>
                                </div>
                            </div>
                        ))}
                    </>
                )}
            </Form.List>
    </div>
);

